export const decodeBase64 = (str?: string): string => {
  if (!str) return '';
  try {
    // decode base64 then decode UTF-8
    return decodeURIComponent(escape(atob(str)));
  } catch (e) {
    console.error('Base64 decoding failed:', e);
    return str; // fallback if decoding fails
  }
};

export const toBase64 = (str: string): string => {
  try {
    return btoa(unescape(encodeURIComponent(str))); // handles UTF-8 safely
  } catch (e) {
    console.error('Base64 encoding failed:', e);
    return '';
  }
};
